import React, { useEffect } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import AmbientBackground from '../ui/AmbientBackground';
import { useTheme } from '../../contexts/ThemeContext';
import { useSidebar } from '../../contexts/SidebarContext';

/**
 * DashboardLayout - Main layout wrapper for authenticated dashboard pages
 * @param {string} title - Page title shown in top bar
 * @param {string} subtitle - Page subtitle (optional)
 * @param {object} userData - User data for sidebar (level, XP, etc.)
 * @param {React.ReactNode} children - Page content
 */
const DashboardLayout = ({ title, subtitle, userData, children }) => {
    const { restoreUserTheme } = useTheme();
    const { isMobile } = useSidebar();

    // Restore user's saved theme when entering dashboard
    useEffect(() => {
        restoreUserTheme();
    }, [restoreUserTheme]);

    const styles = {
        body: {
            display: 'flex',
            minHeight: '100vh',
        },
        mainContent: {
            flex: 1,
            // On mobile, no margin (sidebar is overlay); on desktop, use CSS variable
            marginLeft: isMobile ? 0 : 'var(--sidebar-width)',
            minHeight: '100vh',
            position: 'relative',
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            transition: 'margin-left var(--duration-base) var(--ease-out)',
        },
        content: {
            flex: 1,
            // Responsive padding: smaller on mobile
            padding: isMobile ? 'var(--space-md)' : 'var(--space-2xl)',
        },
    };

    return (
        <div style={styles.body}>
            {/* Ambient Background */}
            <AmbientBackground variant="dashboard" />

            {/* Sidebar */}
            <Sidebar userData={userData} />

            {/* Main Content Area */}
            <main style={styles.mainContent}>
                {/* Top Bar */}
                <TopBar title={title} subtitle={subtitle} />

                {/* Page Content */}
                <div style={styles.content}>
                    {children}
                </div>
            </main>
        </div>
    );
};

export default DashboardLayout;
